import React from "react";
import { FieldLabel, TextField } from "react-invenio-forms";
import PropTypes from "prop-types";
import { Divider, Grid } from "semantic-ui-react";
import { i18next } from "@translations/up/i18next";

export const InternalReviewBoardField = ({ fieldPath, label }) => {
  return (
    <>
      <FieldLabel htmlFor={fieldPath} label={label} />
      <Divider fitted />
      <Grid padded>
        <Grid.Column width="8">
          <TextField
            fieldPath={`${fieldPath}.number`}
            label={i18next.t("Number")}
            required
          />
        </Grid.Column>
        <Grid.Column width="8">
          <TextField
            fieldPath={`${fieldPath}.status`}
            label={i18next.t("Status")}
            required
            width={8}
          />
        </Grid.Column>
      </Grid>
    </>
  );
};

InternalReviewBoardField.propTypes = {
  fieldPath: PropTypes.string,
  label: PropTypes.string,
};

InternalReviewBoardField.defaultProps = {
  fieldPath: "custom_fields.internal_review_board",
  label: i18next.t("Internal review board"),
};
